'use strict';

var cache = require('@apollo/client/cache');

function configureCache(config) {
    var _config_fragments;
    const fragments = cache.createFragmentRegistry(...(_config_fragments = config.fragments) != null ? _config_fragments : []);
    var _config_typePolicies, _config_possibleTypes;
    // console.log(fragments);
    // console.log(config.possibleTypes);
    return {
        fragments,
        typePolicies: (_config_typePolicies = config.typePolicies) != null ? _config_typePolicies : {},
        possibleTypes: (_config_possibleTypes = config.possibleTypes) != null ? _config_possibleTypes : {}
    };
}

module.exports = configureCache;
